<div class="results">
  <p *ngIf="results.length === 0">
    <mat-icon class="success">check</mat-icon>Success, the RSS feed is valid!
  </p>
  <p *ngIf="results.length > 0">
    <mat-icon class="error">close</mat-icon>Errors were detected!
  </p>
  <mat-card *ngFor="let error of results" class="error-card mat-elevation-z0">
    <h4>{{ error.property }}</h4>
    <ul>
      <li *ngFor="let item of error.errorList">
        {{ item }}
      </li>
    </ul>
  </mat-card>
</div>
